import JSLogger from '../jslogger';
import AssetHandler from './asset-handler';
import manifest from '../../../../dist/app.js';

const logger = new JSLogger('assethandler');
export default AssetHandler.create(manifest, logger);
